import { BriefcaseIcon } from "@heroicons/react/solid";
import React from "react";
import { Link } from "react-router-dom";
import resume from "../resume.pdf";

export function NavBar() {
  return (
    <header className="bg-gray-800 md:sticky top-0 z-40">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <p className="title-font font-medium text-white mb-4 md:mb-0">
          <Link to="/" className="ml-3 text-xl text-white hover:text-gray-400">
            Jacob Marthaller
          </Link>
        </p>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700 flex flex-wrap items-center text-base justify-center">
          <Link to="/blog" className="mr-5 text-gray-300 hover:text-white">
            Blog
          </Link>
        </nav>

        <a
          href={resume}
          target="_blank"
          className="inline-flex items-center bg-gray-700 text-gray-300 border-0 py-1 px-3 focus:outline-none hover:bg-gray-600 hover:text-white transition delay-100 duration-300 ease-in-out rounded text-base mt-4 md:mt-0"
          rel="noopener noreferrer"
        >
          Resume
          <BriefcaseIcon className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}
